export const CONFIG_PATH : string = './config.toml';
export const DOCTYPE_PATH: string = './t.doc.toml';
export const RELTYPE_PATH: string = './t.rel.toml';
export const MD          : string = '.md'; // | '.mdx' | '.markdown';
export const TYPE        : string = 'type';
